module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6-7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('h1', [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', {
    staticClass: "colt"
  }, [_vm._v("A New Approach to Eating")])])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Good food has always been central to my life, and that love led me to a career as food editor at one of the top epicurean magazines in the country. For more than twenty years, I directed the food content for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bon Appétit")]), _vm._v(" magazine, delivering delicious recipes to the over seven million readers. It was part of my job to taste all of the recipes we printed. But recently, I had to make a big change in the way I approached food.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("I had celiac disease as a baby, and the doctors informed my mother that if I ate no gluten for my first three years, I would be cured. My mom told me this story from the time I was old enough to understand, and I trusted the information, despite digestive problems my entire life. Not long ago, my symptoms became a lot worse, with agonizing bloating almost every time I ate, frequent gastrointestinal distress, and aching joints. The two indicators that really got my attention were fatigue and weight loss, despite eating enormous quantities of dark chocolate to boost my energy (I’m not complaining about that part). After considerable investigation, it became clear that the gluten ")]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("intolerance had resurfaced and my system was in chaos. I knew immediately that in order to be happy, I had to eat as well as I always had—fresh, simple, farmers’ market–inspired food—but it now had to be free of wheat, rye, barley, and other foods that contain the protein called gluten. Because I am interested in everything about food and cooking, this challenge turned into an enthralling and satisfying project. I attended celiac conferences, read books, and, best of all, experimented in the kitchen.")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I hope you enjoy this book with more than 100 gluten-free recipes from a year of glorious experimentation. I organized it by craving, with chapters of dishes you feel like eating: poultry, seafood, and meat. I often like to eat vegetarian (with perhaps some pancetta thrown in for flavor), so I’ve included a robust meatless chapter, too. There are also a handful of dessert recipes that will satisfy a sweet tooth. In the back of the book, I offer tips and tricks for seasonal, weeknight, and gluten-free eating, including a primer on setting up a gluten-free pantry and a list of sources for some of my favorite gluten-free products.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("The approach I developed involves cooking pleasing dishes that are naturally gluten-free, rather than creating disappointing versions of recipes that rely on wheat, rye, or barley. I have tried out dozens of gluten-free pastas that are now available and discovered, to my delight, that a lot of them are really good. I have found excellent quinoa, corn, and mixed-grain products to replace semolina pasta and allow me to keep enjoying many of my favorite classic pasta dishes. I’ve always loved Asian noodle dishes, too, and then I realized that many of them, made from mung beans or rice, are naturally free of gluten.")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Light, flavorful, and modern sauces for main dishes have always been a favorite in my house. Since changing my diet, I have expanded my repertory. Inside this book you’ll find many of them: a vibrant salsa verde; pesto laced with nuts, herbs, and lemon; bold vinaigrettes and olive sauces; mayonnaise augmented with fresh herbs; corn or tomato relishes; fresh fruit salsas; and quick guacamole.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("For dishes that I used to enjoy with wheat-based pastas or crusty bread, I’ve come up with several starchy, gluten-free staples that are just as satisfying. ")]), _c('span', {
    attrs: {
      "href": "#/cap03#page115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Weeknight Polenta (see recipe)")]), _vm._v(" takes only minutes to prepare in the microwave. It serves as a satisfying base for sautéed mushrooms or braised chicken or shrimp. "), _c('a', {
    attrs: {
      "href": "#/cap01#page51"
    }
  }, [_vm._v("Polenta Pizza Crust is made from a similar polenta, spread on a sheet pan and baked (see recipe)")]), _vm._v(". This transforms it into an excellent foundation for tomato and melted cheese toppings. Quinoa, which takes only minutes to cook, makes a nutritious, high-protein side dish for almost any main dish in my house. There are dozens of ways to add flavor and texture to cooked "), _c('span', {
    attrs: {
      "href": "#/cap02#page75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("quinoa (see recipe)")]), _vm._v(". "), _c('a', {
    attrs: {
      "href": "#/cap01#page26"
    }
  }, [_vm._v("Socca, naturally gluten-free chickpea pancakes (see recipe)")]), _vm._v(", can be baked until crisp and then garnished with rich burrata cheese and greens; or cooked into a tender base for sautéed summer squash and Gruyère cheese. I also use socca as a dipper or wrapper in a multitude of ways. Potatoes are a mainstay in my house. Yukon gold potatoes, steamed and then "), _c('span', {
    attrs: {
      "href": "#/cap04#page165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("smashed with fresh herbs, olive oil, and a little broth (see recipe)")]), _vm._v(" are great with sautéed steaks and fish fillets. Cornbread, fragrant, tender, and baked in a "), _c('span', {
    attrs: {
      "href": "#/cap03#page138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("cast-iron skillet (see recipe)")]), _vm._v(" grew from my love of artisan breads. My recipe is so easy, it can be put together on a weeknight and is the dish I am perhaps most excited about in this book. I urge you to get into the kitchen and make one right away.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p9.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("When I want to enclose foods in wrappers, corn tortillas are a reliable staple. Following Mexican tradition, I toast them over a hot flame and wrap them around almost anything: grilled chicken, sautéed tuna, spicy beef, mashed black beans and feta cheese, and leftovers. Tortillas also make a good replacement for Mandarin pancakes to serve with ")]), _c('span', {
    attrs: {
      "href": "#/cap04#page155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Mu Shu Pork (see recipe)")]), _vm._v(". Be sure to check on the label that the tortillas are gluten free. Other wrappers that I developed are "), _c('a', {
    attrs: {
      "href": "#/cap01#page38"
    }
  }, [_vm._v("Herbed Egg Crepes (see recipe)")]), _vm._v(", which are actually delicate, super-thin omelets—and they are a joy to make. I fill them with ricotta cheese, sautéed mushrooms, prosciutto, arugula, or any other filling that strikes my fancy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("When I crave crisp crusts on fish or chicken, I use gluten-free ingredients rather than wheat flour or wheat-based bread crumbs to coat them. Dusted with cornmeal or gluten-free flour mix, these tender foods work well for quick sautés. For roasting in a hot oven, I rely on almonds, pecans, and tortilla chips as breadings, but you can also experiment with crushed potato chips and "), _c('span', {
    attrs: {
      "href": "#/cap03#page128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("gluten-free corn flakes for kid-friendly meals (see recipe)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("For weeknight desserts, I depend on fresh seasonal fruit, served with cheese or nuts in the shell, topped with sweetened Greek yogurt, or quickly sautéed and spooned over purchased ice cream. On weekends, I’ll bake a big batch of meringue cookies (flavored with spices, nuts, or chocolate chips) and store them in a tin to enjoy after a busy day. Other handy desserts to make on the weekend and have ready in the freezer are oatmeal cookies. Recently, I baked a version for my wedding rehearsal dinner and set them out for guests to enjoy. Not one of them guessed they were gluten-free, and I still get requests for the recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The best part about my new gluten-free lifestyle is that I don’t feel deprived. I have served these dishes to my gluten-eating pals, and to my husband, Steve. No one ever noticed anything was missing, nor suspected anything had changed at my table. I hope you and your family will enjoy the recipes from this book as much we do.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p11.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ef38cc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap00b.vue
// module id = 69
// module chunks = 0